import { wrapAllInParentDiv } from '../utils/wrapAllInParentDiv';
import { wrap } from '../utils/wrap';

// Fonction pour créer la div englobante principale
const makeParentDiv = (className = '') => {
    const parentClass = ['has-colonnage', 'container-grid'];
    if (className !== '') {
        parentClass.push(className);
    }
    // On crée la div englobante et on lui rajoute une classe
    const newDiv = document.createElement('div');
    newDiv.classList.add(...parentClass);
    return newDiv;
}

const doubleWrapping = (cssTarget, className = '') => {
    // Premier wrap
    wrapAllInParentDiv(cssTarget, ['paragraphe__inner', 'to-wrap-again']);
    // Ensuite, on va chercher la classe temporaire 'to-wrap-again' dans le DOM
    const nodes = document.querySelectorAll('.to-wrap-again');

    // Pour chacun des nouveaux nœuds créés
    nodes.forEach(node => {
        // On réalise un 2ème wrap utilisant makeParentDiv()
        const newDiv = makeParentDiv(className);
        wrap(node, newDiv);
        node.classList.remove('to-wrap-again');
    });
}

doubleWrapping('[class*="PRS_WIDTH"]:not([class*="PRS_FOND"])');
doubleWrapping('[class*="PRS_FOND_NOIR"][class*="PRS_WIDTH"]', 'PRS_FOND_NOIR');
doubleWrapping('[class*="PRS_FOND_GRIS"][class*="PRS_WIDTH"]', 'PRS_FOND_GRIS');


const removeClassPRSColonne = (prs) => {
// Pour les fonds noirs en colonne, on leur retire leur classe PRS_FOND_NOIR
    const fondsColonne = document.querySelectorAll(`.paragraphe__inner > .${prs}`);
    fondsColonne.forEach(element => {
        element.classList.remove(prs);
    })
}

removeClassPRSColonne('PRS_FOND_NOIR');
removeClassPRSColonne('PRS_FOND_GRIS');
